import { render, staticRenderFns } from "./specimens.vue?vue&type=template&id=4f9505c0"
import script from "./specimens.vue?vue&type=script&lang=js"
export * from "./specimens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports